module.exports = __webpack_public_path__ + "roboto-mediumitalic-webfont.655dfd6d71b33bb4b423.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/roboto-mediumitalic-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto-mediumitalic-webfont.ttf
// module chunks = styles